/**
 * Parent / sibling site links (e.g. Activities & Events on mysizzleisland.com).
 *
 * Set in Coolify or .env:
 *   REACT_APP_PARENT_ACTIVITIES_URL=https://www.example.com/activities-events
 */
export const PARENT_ACTIVITIES_EVENTS_URL = (
  process.env.REACT_APP_PARENT_ACTIVITIES_URL ||
  process.env.REACT_APP_SIZZLE_PARENT_ACTIVITIES_URL ||
  ''
).trim();
